import React from 'react'
import { useIntl } from 'react-intl'
import Headline from '@atoms/Headline/Headline'

const ErrorBasketUnknown = () => {
  const { formatMessage } = useIntl()
  return (
    <Headline tag='h4'>
      {formatMessage({
        id: 'msp.minicart.error.unknown',
        defaultMessage:
          "The basket information couldn't be loaded, please reload the page"
      })}
    </Headline>
  )
}

const ErrorBasketEmpty = () => {
  const { formatMessage } = useIntl()
  return (
    <Headline tag='h4' textPosition='center' className='px-5 py-10'>
      {formatMessage({
        id: 'msp.minicart.no.items.basket',
        defaultMessage: "There're no items in the basket"
      })}
    </Headline>
  )
}

export { ErrorBasketUnknown, ErrorBasketEmpty }
